if (!customElements.get('testimonial-video')) {
  class TestimonialVideo extends HTMLElement {
    constructor() {
      super();
      this.onPlayClick = this.handlePlayClick.bind(this);
      this.onPointerEnter = this.handlePointerEnter.bind(this);
      this.onPointerLeave = this.handlePointerLeave.bind(this);
      this.previewWanted = false;
    }

    connectedCallback() {
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('[data-play-toggle]');
      this.playButton?.addEventListener('click', this.onPlayClick);
      // Hovering starts a muted preview. It stays out of the way on touch devices, where
      // a "hover" only fires on the tap that is meant to open the video anyway, and for
      // visitors who asked for less motion - accordion.js honours the same setting.
      const canPreview =
        window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (canPreview) {
        this.addEventListener('mouseenter', this.onPointerEnter);
        this.addEventListener('mouseleave', this.onPointerLeave);
      }
    }

    // The clips are preload="none", so nothing is fetched for cards nobody touches.
    // Buffering starts with the first sign of intent: hovering or pressing play.
    requestBuffer() {
      if (this.video && this.video.preload !== 'auto') this.video.preload = 'auto';
    }

    disconnectedCallback() {
      this.playButton?.removeEventListener('click', this.onPlayClick);
      this.removeEventListener('mouseenter', this.onPointerEnter);
      this.removeEventListener('mouseleave', this.onPointerLeave);
    }

    handlePlayClick() {
      if (!this.video) return;
      this.requestBuffer();
      this.previewWanted = false;
      this.toggleAttribute('data-previewing', false);
      this.video.muted = false;
      this.video.setAttribute('controls', '');
      this.video.play().catch(() => {});
      this.toggleAttribute('data-playing', true);
    }

    handlePointerEnter() {
      // Once the clip runs with sound and controls it belongs to the visitor; the
      // preview must not touch it any more.
      if (!this.video || this.hasAttribute('data-playing')) return;
      this.previewWanted = true;
      this.requestBuffer();
      this.video.muted = true;
      this.video
        .play()
        .then(() => {
          // Hide the play badge when the picture really moves, and not at all if the
          // pointer left again or the browser refused to play.
          if (this.previewWanted) this.toggleAttribute('data-previewing', true);
        })
        .catch(() => {});
    }

    handlePointerLeave() {
      if (!this.video || this.hasAttribute('data-playing')) return;
      this.previewWanted = false;
      this.toggleAttribute('data-previewing', false);
      this.video.pause();
      // Back to the poster frame, so every card looks the same again.
      this.video.currentTime = 0;
    }
  }

  customElements.define('testimonial-video', TestimonialVideo);
}
